/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreOpsQuestionKind } from './PreOpsQuestionKind';
import {
    PreOpsQuestionKindFromJSON,
    PreOpsQuestionKindFromJSONTyped,
    PreOpsQuestionKindToJSON,
    PreOpsQuestionKindToJSONTyped,
} from './PreOpsQuestionKind';

/**
 * 
 * @export
 * @interface PreOpsQuestionCreate
 */
export interface PreOpsQuestionCreate {
    /**
     * 
     * @type {PreOpsQuestionKind}
     * @memberof PreOpsQuestionCreate
     */
    kind: PreOpsQuestionKind;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestionCreate
     */
    body: string;
    /**
     * 
     * @type {string}
     * @memberof PreOpsQuestionCreate
     */
    checklistId?: string | null;
}



/**
 * Check if a given object implements the PreOpsQuestionCreate interface.
 */
export function instanceOfPreOpsQuestionCreate(value: object): value is PreOpsQuestionCreate {
    if (!('kind' in value) || value['kind'] === undefined) return false;
    if (!('body' in value) || value['body'] === undefined) return false;
    return true;
}

export function PreOpsQuestionCreateFromJSON(json: any): PreOpsQuestionCreate {
    return PreOpsQuestionCreateFromJSONTyped(json, false);
}

export function PreOpsQuestionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreOpsQuestionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'kind': PreOpsQuestionKindFromJSON(json['kind']),
        'body': json['body'],
        'checklistId': json['checklistId'] == null ? undefined : json['checklistId'],
    };
}

export function PreOpsQuestionCreateToJSON(json: any): PreOpsQuestionCreate {
    return PreOpsQuestionCreateToJSONTyped(json, false);
}

export function PreOpsQuestionCreateToJSONTyped(value?: PreOpsQuestionCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'kind': PreOpsQuestionKindToJSON(value['kind']),
        'body': value['body'],
        'checklistId': value['checklistId'],
    };
}

